import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from './Reveal';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  return (
    <footer className="footer">
      <div className="container">
        <Reveal className="footer-content">
          <div className="footer-section">
            <h3>Apex Painting Solutions</h3>
            <p>Professional painting tools manufacturer serving global markets with quality products since 2000.</p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/quality">Quality Assurance</Link></li>
              <li><Link to="/shipping">Export & Shipping</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Product Catalogue</h3>
            <ul>
              <li><Link to="/categories">Paint Application Tools</Link></li>
              <li><Link to="/categories">Surface Preparation</Link></li>
              <li><Link to="/categories">Sanding & Polishing Tools</Link></li>
              <li><Link to="/products">All Products</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact</h3>
            <ul>
              <li>Company Address Street</li>
              <li>City, State, ZIP Code</li>
              <li>Phone: +1 234 567 8900</li>
              <li>Email: info@apex.com</li>
            </ul>
          </div>
        </Reveal>

        <Reveal as="div" className="footer-newsletter" delay={0.1}>
          <h3>Subscribe to Our Newsletter</h3>
          <form onSubmit={handleSubmit} className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="footer-subscribe-btn">Subscribe</button>
          </form>
        </Reveal>

        <div className="footer-bottom">
          <p>&copy; 2026 Apex Painting Solutions. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/contact">Bulk Order Procurement</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
